import {GET_PAYMENT_CURRENCY} from "./currencyActionTypes";

export const setPaymentMethods = (paymentMethod) => ({
    type: GET_PAYMENT_CURRENCY,
    payload: paymentMethod
});